/* FP V3 — Patch server-rendered variant cards.
 * Liquid renders one <li class="fp-variant-card" data-fp-variant-*> per color variant.
 * This script updates the inner image src + product link to the variant's specifics.
 */
(function() {
  function patchCards() {
    const cards = document.querySelectorAll('li.fp-variant-card:not([data-fp-patched])');
    cards.forEach(card => {
      card.setAttribute('data-fp-patched', '1');

      const url = card.dataset.fpVariantUrl;
      const imgSrc = card.dataset.fpVariantImage;

      // Update all product links inside the card to the variant URL
      if (url) {
        card.querySelectorAll('a[href*="/products/"]').forEach(a => {
          a.setAttribute('href', url);
        });
      }

      // Update the main product image if a variant-specific image exists
      if (imgSrc) {
        card.querySelectorAll('img').forEach(img => {
          // Skip swatches and icons
          if (img.closest('.swatch, .swatch-list, [class*="swatch"], [class*="icon"]')) return;
          // Skip very small images (likely icons/thumbs)
          if (img.width && img.width < 80) return;
          img.setAttribute('src', imgSrc);
          img.removeAttribute('srcset');
          img.setAttribute('loading', 'lazy');
        });
      }

      // Swatches stay visible on each split card (Atlas pattern: dot per color)
    });
  }

  function init() {
    if (!document.querySelector('results-list')) return;
    patchCards();
    // Re-run on filter/pagination updates
    const list = document.querySelector('results-list');
    const mo = new MutationObserver(() => {
      clearTimeout(window.__fpSplitDebounce);
      window.__fpSplitDebounce = setTimeout(patchCards, 100);
    });
    mo.observe(list, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
